import * as fontkit from 'fontkit';

// Font definitions - same as React PDF styles
export const MONTSERRAT_FONTS = [
  // Italic
  {
    src: 'https://fonts.gstatic.com/s/montserrat/v25/JTUFjIg1_i6t8kCHKm459Wx7xQYXK0vOoz6jq6R8aX8.ttf',
    fontStyle: 'italic',
    fontWeight: 100,
  },
  {
    src: 'https://fonts.gstatic.com/s/montserrat/v25/JTUFjIg1_i6t8kCHKm459Wx7xQYXK0vOoz6jqyR9aX8.ttf',
    fontStyle: 'italic',
    fontWeight: 200,
  },
  {
    src: 'https://fonts.gstatic.com/s/montserrat/v25/JTUFjIg1_i6t8kCHKm459Wx7xQYXK0vOoz6jq_p9aX8.ttf',
    fontStyle: 'italic',
    fontWeight: 300,
  },
  {
    src: 'https://fonts.gstatic.com/s/montserrat/v25/JTUFjIg1_i6t8kCHKm459Wx7xQYXK0vOoz6jq6R9aX8.ttf',
    fontStyle: 'italic',
    fontWeight: 400,
  },
  {
    src: 'https://fonts.gstatic.com/s/montserrat/v25/JTUFjIg1_i6t8kCHKm459Wx7xQYXK0vOoz6jq5Z9aX8.ttf',
    fontStyle: 'italic',
    fontWeight: 500,
  },
  {
    src: 'https://fonts.gstatic.com/s/montserrat/v25/JTUFjIg1_i6t8kCHKm459Wx7xQYXK0vOoz6jq3p6aX8.ttf',
    fontStyle: 'italic',
    fontWeight: 600,
  },
  {
    src: 'https://fonts.gstatic.com/s/montserrat/v25/JTUFjIg1_i6t8kCHKm459Wx7xQYXK0vOoz6jq0N6aX8.ttf',
    fontStyle: 'italic',
    fontWeight: 700,
  },
  {
    src: 'https://fonts.gstatic.com/s/montserrat/v25/JTUFjIg1_i6t8kCHKm459Wx7xQYXK0vOoz6jqyR6aX8.ttf',
    fontStyle: 'italic',
    fontWeight: 800,
  },
  {
    src: 'https://fonts.gstatic.com/s/montserrat/v25/JTUFjIg1_i6t8kCHKm459Wx7xQYXK0vOoz6jqw16aX8.ttf',
    fontStyle: 'italic',
    fontWeight: 900,
  },

  // Regular
  {
    src: 'https://fonts.gstatic.com/s/montserrat/v25/JTUHjIg1_i6t8kCHKm4532VJOt5-QNFgpCtr6Uw-.ttf',
    fontStyle: 'normal',
    fontWeight: 100,
  },
  {
    src: 'https://fonts.gstatic.com/s/montserrat/v25/JTUHjIg1_i6t8kCHKm4532VJOt5-QNFgpCvr6Ew-.ttf',
    fontStyle: 'normal',
    fontWeight: 200,
  },
  {
    src: 'https://fonts.gstatic.com/s/montserrat/v25/JTUHjIg1_i6t8kCHKm4532VJOt5-QNFgpCs16Ew-.ttf',
    fontStyle: 'normal',
    fontWeight: 300,
  },
  {
    src: 'https://fonts.gstatic.com/s/montserrat/v25/JTUHjIg1_i6t8kCHKm4532VJOt5-QNFgpCtr6Ew-.ttf',
    fontStyle: 'normal',
    fontWeight: 400,
  },
  {
    src: 'https://fonts.gstatic.com/s/montserrat/v25/JTUHjIg1_i6t8kCHKm4532VJOt5-QNFgpCtZ6Ew-.ttf',
    fontStyle: 'normal',
    fontWeight: 500,
  },
  {
    src: 'https://fonts.gstatic.com/s/montserrat/v25/JTUHjIg1_i6t8kCHKm4532VJOt5-QNFgpCu170w-.ttf',
    fontStyle: 'normal',
    fontWeight: 600,
  },
  {
    src: 'https://fonts.gstatic.com/s/montserrat/v25/JTUHjIg1_i6t8kCHKm4532VJOt5-QNFgpCuM70w-.ttf',
    fontStyle: 'normal',
    fontWeight: 700,
  },
  {
    src: 'https://fonts.gstatic.com/s/montserrat/v25/JTUHjIg1_i6t8kCHKm4532VJOt5-QNFgpCvr70w-.ttf',
    fontStyle: 'normal',
    fontWeight: 800,
  },
  {
    src: 'https://fonts.gstatic.com/s/montserrat/v25/JTUHjIg1_i6t8kCHKm4532VJOt5-QNFgpCvC70w-.ttf',
    fontStyle: 'normal',
    fontWeight: 900,
  },
];

// Font cache to avoid re-fetching
const fontCache = new Map<string, any>();

/**
 * Loads a Montserrat font with the specified weight and style for use with fontkit
 * @param fontWeight - Font weight (100-900)
 * @param fontStyle - Font style ('normal' | 'italic')
 * @returns Promise<fontkit font instance>
 */
export async function loadMontserratFont(
  fontWeight: number = 400,
  fontStyle: 'normal' | 'italic' = 'normal'
): Promise<any> {
  // Create cache key combining weight and style
  const cacheKey = `${fontWeight}-${fontStyle}`;

  // Check cache first
  if (fontCache.has(cacheKey)) {
    return fontCache.get(cacheKey);
  }

  // Find the best matching font
  const matchingFonts = MONTSERRAT_FONTS.filter((font) => font.fontStyle === fontStyle);
  const availableWeights = matchingFonts.map((font) => font.fontWeight);
  const normalizedWeight = availableWeights.reduce((prev, curr) =>
    Math.abs(curr - fontWeight) < Math.abs(prev - fontWeight) ? curr : prev
  );

  const fontDef = matchingFonts.find((font) => font.fontWeight === normalizedWeight);

  if (!fontDef) {
    throw new Error(`No font found for weight ${fontWeight} and style ${fontStyle}`);
  }

  try {
    const response = await fetch(fontDef.src);

    if (!response.ok) {
      throw new Error(`Failed to fetch font: ${response.statusText}`);
    }

    const fontBuffer = await response.arrayBuffer();
    // Use Uint8Array instead of Buffer for browser compatibility
    const font = fontkit.create(new Uint8Array(fontBuffer) as any);

    // Cache the font
    fontCache.set(cacheKey, font);

    return font;
  } catch (error) {
    console.error(`Failed to load Montserrat font weight ${fontWeight}, style ${fontStyle}:`, error);

    // Fallback to normal weight 400 if available
    const fallbackKey = '400-normal';
    if (cacheKey !== fallbackKey && fontCache.has(fallbackKey)) {
      return fontCache.get(fallbackKey);
    }

    throw error;
  }
}

/**
 * Preloads commonly used font weights (normal style only)
 */
export async function preloadCommonFonts(): Promise<void> {
  const commonWeights = [400, 500, 600, 700]; // Normal, medium, semi-bold, bold

  await Promise.all(
    commonWeights.map((weight) =>
      loadMontserratFont(weight, 'normal').catch((error) =>
        console.warn(`Failed to preload font weight ${weight}:`, error)
      )
    )
  );
}

preloadCommonFonts();

/**
 * Gets a preloaded font synchronously (for use in Mustache functions)
 * @param fontWeight - Font weight (100-900)
 * @param fontStyle - Font style ('normal' | 'italic')
 * @returns fontkit font instance or null if not preloaded
 */
export function getPreloadedFont(fontWeight: number = 400, fontStyle: 'normal' | 'italic' = 'normal'): any | null {
  const cacheKey = `${fontWeight}-${fontStyle}`;
  return fontCache.get(cacheKey) || null;
}

/**
 * Gets the appropriate font weight from a CSS font-weight value
 */
export function normalizeFontWeight(cssWeight: string | number): number {
  if (typeof cssWeight === 'number') return cssWeight;

  const weightMap: { [key: string]: number } = {
    thin: 100,
    'extra-light': 200,
    light: 300,
    normal: 400,
    medium: 500,
    'semi-bold': 600,
    bold: 700,
    'extra-bold': 800,
    black: 900,
  };

  return weightMap[cssWeight] || parseInt(cssWeight) || 400;
}
